module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f2"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "id": "chr"
    }
  }), _vm._v("CHRONOLOGY")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1940")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("July 21")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Born James Enos Clyburn in Sumter, South Carolina, to Almeta Dizzley Clyburn and the Reverend Enos Lloyd Clyburn, a Church of God minister")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1957")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("May")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Graduates from Mather Academy, an all-black private high school in Camden, South Carolina")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("September")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Enrolls at South Carolina State College (now University), in Orangeburg, South Carolina")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1960")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("February 25")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Helps to plan and participates in a march protesting the segregated lunch counter at the Kress store in Orangeburg")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("March 15")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("As one of the Orangeburg Seven organizers and leaders of a major demonstration against segregated lunch counters at three Orangeburg businesses, one of the largest such protests in the South, is arrested, jailed, and eventually found guilty of “breach of the peace,” a conviction later overturned by the U.S. Supreme Court")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1961")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("March 15")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Is arrested and jailed for participating in a civil rights demonstration at the State House in Columbia, South Carolina, which leads to the landmark breach of the peace case "), _c('em', [_vm._v("Edwards v. South Carolina")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("June 24")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Marries Emily England")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("December")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Completes course work for a B.A. at S.C. State")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1962")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("January")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Begins teaching eighth-grade English and social studies at Simonton School in Charleston, South Carolina")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("March 22")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Birth of Mignon L. Clyburn")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("May")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Receives degree from S.C. State")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _vm._v("September")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Moves to C. A. Brown High School in Charleston to teach world history and soon begins volunteer work at the Our Lady of Mercy Neighborhood House across the street and starts the first Big Brother (and later Big Sister) program for African American children in South Carolina")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1965")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("February")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Becomes an employment counselor with the Youth Opportunity Center (YOC) in Charleston")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("October")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Transfers to the YOC in Columbia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1966")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("April")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Becomes director of the Neighborhood Youth Corps in Charleston")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1968")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("October")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Becomes executive director of the South Carolina Commission for Farm Workers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1969")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("August 16")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Birth of Jennifer Lynn Clyburn")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1970")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("June")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Wins the Democratic primary for S.C. House of Representatives from Charleston")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("November")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Loses first general election")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1971")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("January")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("As assistant to the governor for human resource development on the staff of Governor John C. West, becomes the first African American to hold an executive position on a South Carolina governor’s staff")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("May")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Elected the first African American president of the South Carolina Young Democrats")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1973")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("July 27")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Birth of Angela Denise Clyburn")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1974")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("October")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Becomes commissioner of the South Carolina Human Affairs Commission")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('em', [_vm._v("1978")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("June")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Loses second political election in a Democratic primary runoff (after finishing first in a three-way race) in a statewide campai"), _c('em', [_vm._v("g")]), _vm._v("n to serve as South Carolina "), _c('em', [_vm._v("s")]), _vm._v("ecretary of "), _c('em', [_vm._v("s")]), _vm._v("tate")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1986")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("June")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Loses third political election in a Democratic primary, again for South Carolina secretary of state")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1992")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("February")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Resigns as commissioner of the South Carolina Human Affairs Commission to run for Congress")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("August")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Wins a five-man Democratic primary race for "), _c('em', [_vm._v("C")]), _vm._v("ongress without a runoff")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("November")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Wins general election to "), _c('em', [_vm._v("C")]), _vm._v("ongress, becoming the first African-American to serve in the U.S. House of Representatives from South Carolina since the nineteenth century")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('em', [_vm._v("1993")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("January")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Begins first term as representative for the Sixth District of South Carolina in the United States Congress")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablex"
  }, [_c('em', [_vm._v("1993–1994")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1t"
  }, [_vm._v("Serves as copresident, with Democrat Eva Clayton of North Carolina, of his 110-member congressional freshman class")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablex"
  }, [_c('em', [_vm._v("1999–2001")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1t"
  }, [_vm._v("Serves as chair of the Congressional Black Caucus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablex"
  }, [_c('em', [_vm._v("2003–2005")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1t"
  }, [_vm._v("Serves as vice chair of the House Democratic Caucus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablex"
  }, [_c('em', [_vm._v("2005–2006")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1t"
  }, [_vm._v("Serves as chair of the House Democratic Caucus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabley"
  }, [_c('em', [_vm._v("2007–2010")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Serves as House majority whip")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablex"
  }, [_c('em', [_vm._v("2011–present")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1t"
  }, [_vm._v("Serves as assistant House Democratic leader")]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30994936","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chronology.vue
// module id = 87
// module chunks = 0